import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { ProviderModel } from '../../common/models/Provider.Model';
import { ItemService} from '../../catalog/item/item.service';
import { Item } from '../../common/models/Item.Model';
import { UserLogin } from '../../common/models/UserLogin.Model';
import { DatePipe } from '@angular/common';
import { ReportsService } from '../reports.service';
import { GlobalFunctionsService } from '../../common/functions/global-functions.service';
import { MultiselectOption } from '../../common/ceq-multiselect/ceq-multiselect.component';
import { Unit } from '../../common/models/Unit.Model';


@Component({
  selector: 'app-equipmentio',
  templateUrl: './equipmentio.component.html',
  styleUrls: ['./equipmentio.component.scss']
})
export class EquipmentioComponent implements OnInit {

  constructor(
    private globalFunctionService: GlobalFunctionsService,
    private settings: SettingsService,
    private ItemsServices: ItemService,
    private reportService: ReportsService,

  ) { }

  hasta: string = "";
  desde: string = "";
  working: boolean = false;
  providers: ProviderModel[] = [];
  nodesUser: Unit[] = [];
  selectedNodeName: string;

  typeList: MultiselectOption[] = [];
  organizationSelected: string = '0';
  organizacionList: Unit[];
  selectedNode: Unit;
  inputKeyword: string = 'UnitDescription';

  typeCheckedList: MultiselectOption[] = this.typeList;
  typeSelected: string = this.typeList.map(x => x.Id).join('|');

  itemsList: MultiselectOption[] = [];

  itemsCheckedList: MultiselectOption[] = this.typeList;
  itemsSelected: string = this.typeList.map(x => x.Id).join('|');

  tiposSelected: string = "0";

  region: Unit[];
  regionSelected: string = '0';
  userLogin: UserLogin;
  datepipe: DatePipe = new DatePipe('en-US');
  downloading: boolean = false;

  ngOnInit(): void {
    this.userLogin = this.settings.getUser();
    this.globalFunctionService.canOperate();
    this.globalFunctionService.hasFSBRPending();
    this.desde = new Date().toISOString().split('T')[0];
    this.hasta = new Date().toISOString().split('T')[0];


    this.desde = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.hasta = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.MultiChecks();
    this.getOrganizacion();
    this.getItems();
  }

  getOrganizacion(): void {
    this.working = true;
    let userId=0;
    let org=1;
    let user = JSON.parse(localStorage.getItem("user"));
     if (user != null && user != undefined) {
       userId=user.Id;
       org=user.Org;
     }
    this.reportService.getOrganizacionesByUser(org,userId).toPromise().then((regiones: Unit[]) => {
      this.organizacionList = regiones;
      this.organizationSelected = '0';
      if(this.organizacionList != null){
        if(this.organizacionList.length > 0){
          this.organizationSelected = this.organizacionList[0].UnitId.toString();
        }
      }
      this.getRegion();
    }).catch(() => {
      this.globalFunctionService.messageToast(`Ocurrió un error al obtener la organización`, 'error');
    });
  }

  getRegion() {
    this.working == true;
    this.reportService.getUserRegions(this.userLogin.Org, this.userLogin.Id, this.organizationSelected).toPromise().then((resp: Unit[]) => {
      this.region = resp;
      this.getNodes();
    })
    .catch(() => {
      this.working = false;
    });
  }

  getNodes() {
    this.nodesUser = [];
    this.selectedNodeName = "";
    this.working = true;
    this.reportService.getUserNodesByRegion(this.userLogin.Org, this.userLogin.Id, this.regionSelected).toPromise().then((resp: any[]) => {
      resp.map((x) => {
        var a: Unit = new Unit();
        (a.UnitId = x.UnitId),
          (a.OrgId = x.Org),
          (a.UnitDescription = x.UnitDes),
          (a.LevelType = x.UnitLevel == 'Centro de Ventas' ? 'CEVE' : 'FAB');
        this.nodesUser.push(a);
      });
    }).catch((err) => {
      console.log(err);
      this.globalFunctionService.messageToast(`Hubo un error al obtener la información`, 'error');
    }).finally(() => {
      this.working = false;
    });
  }

  
  MultiChecks(){
    this.typeList = [
      { Checked: true, Id: '0', Text: 'Todos' },
      { Checked: true, Id: '1', Text: 'Compras' },
      { Checked: true, Id: '2', Text: 'Recuperacion de seguridad' },
      { Checked: true, Id: '3', Text: 'Cobro Colaborador' },
      { Checked: true, Id: '4', Text: 'Perdida Fortuita' },
      { Checked: true, Id: '5', Text: 'Otras Bajas' },
      { Checked: true, Id: '6', Text: 'Bajas por Manejo' },
      { Checked: true, Id: '7', Text: 'Misceláneos' },
    ]

    this.typeSelected = this.typeList.map(x => x.Id).join(',');

  }

  onTypeFilterChange(event: MultiselectOption[]) {
    this.typeCheckedList = event;
    this.typeSelected = event.map(x => x.Id).join('|');
  }

  ontypeItemCheckedChange(event: MultiselectOption) {
    this.typeSelected = this.typeCheckedList.map(x => x.Id).join(',');
  }

  onItemsFilterChange(event: MultiselectOption[]) {
    this.itemsCheckedList = event;
    this.itemsSelected = event.map(x => x.Id).join('|');
  }

  onItemsItemCheckedChange(event: MultiselectOption) {
    this.itemsSelected = this.typeCheckedList.map(x => x.Id).join(',');
  }

 
  getItems() {
    this.ItemsServices
      .GetItems()
      .toPromise()
      .then((resp: Item[]) => {
        
        this.itemsList = [
          { Checked: true, Id: '0', Text: 'Todos' },
        ]
        resp.map((x) => {
          {
            let ut = {Checked: true, Id: x.ItemId, Text: x.ItemDescription};
            this.itemsList.push(ut);
            
          }
          this.itemsSelected = this.itemsList.map(x => x.Id).join(',');
        });

      })
      .catch();
  }

  clearNode() {
    this.selectedNode = undefined;
    this.selectedNodeName = "";
    return;
  }

  changeNode(event: any) {
    this.selectedNode = event;
  }

  download() {
      let f1 = new Date(this.desde);
      let f2 = new Date(this.hasta);
      let unitID:number = 0;

      if (this.selectedNode == undefined || this.selectedNode.UnitId == undefined || this.selectedNode.UnitId == null) {
        unitID = 0;
      }else{
        unitID = this.selectedNode.UnitId;
      }

      if (f1.toISOString() >  f2.toISOString()) {
        this.globalFunctionService.messageToast(`Error La fecha desde no puede ser mayor a la fecha hasta, verifique.`, 'error');
        this.downloading = false;
        return;
      }

      if (this.itemsSelected.length < 1) {
        this.globalFunctionService.messageToast(`Debe seleccionar un Equipo o Todos antes de continuar.`, 'warning');
        this.downloading = false;
        return;
      }

      if (this.typeSelected.length < 1) {
       this.globalFunctionService.messageToast(`Debe seleccionar un tipo o Todos antes de continuar.`, 'warning');
       this.downloading = false;
        return;
      }

      this.reportService.getRepEquipmentIOExcel(this.organizationSelected,
        this.regionSelected,
        unitID,
        this.desde,
        this.hasta,
        this.typeSelected,
        this.itemsSelected).subscribe((resp: any) => {

      if (resp == null) {
        this.downloading = false;
        this.globalFunctionService.messageToast(`No se ha encontrado información.`, 'warning');
        return;
      }
      console.log("termino llamada");

      let blob = new Blob([resp], { type: resp.type });

      const anchor = document.createElement('a');

      anchor.download = `CEQ-EquipmentIO.xlsx`;
      anchor.href = (window.webkitURL || window.URL).createObjectURL(blob);
      anchor.click();
      this.downloading = false;

      }, err => {
        this.downloading = false;
        this.globalFunctionService.messageToast(`Error en la invocación.`, 'warning');
        console.log(err);
      });


  }

}




export class StatusDTO {
  Id: string;
  Description: string;

}
